import React from 'react';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import Transmittal from 'src/models/dlcLease/Transmittal';

interface ITransmittalCardComponentProps {
    transmittal: Transmittal;

    onUpdateTransmittal: (transmittal: Transmittal) => void;
}

const TransmittalCard = (props: ITransmittalCardComponentProps) => {
    
    const actions: ContextMenuAction[] = [{ text: 'Manage', action: () => props.onUpdateTransmittal(props.transmittal) }];
    
    return (
        <Card
            badge={`${props.transmittal?.transmit_no || 'N/A'}`}
            newContext={true}
            showMenu={true}
            contextActions={actions}
            collapse={true}
        >
            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '1.7rem' }}>
                    <div style={{width: '10%'}}>
                        <span 
                            className="data"
                        >
                            {props?.transmittal?.transmit_no || 'N/A'}
                        </span>
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.transmittal?.doc_type}
                    </div>
                    <div style={{width: '20%'}}>
                        {props?.transmittal?.doc_date}
                    </div>
                    <div style={{width: '40%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap'}}>
                        {props?.transmittal?.notary}
                    </div>
                    <div style={{width: '20%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap'}} >
                        {props?.transmittal?.phone}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TransmittalCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/TransmittalCard.tsx